import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { GetMachine } from "../../fetchs";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class Brand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      loading: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    const machineId = this.props.match.params.machineId;
    if (machineId) {
      this.loadMachine(machineId);
    }
  }

  loadMachine = (id) => {
    this.setState({ loading: true });
    GetMachine(id)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            data: responseJson,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component='h1' variant='h4' align='center'>
              نمایش دفترچه خودرو
            </Typography>
            <div className='tableWrapper'>
              <Table
                className='table'
                aria-labelledby='tableTitle'
                size={"medium"}
              >
                <TableBody>
                  {/* ------------------------------------- Water ------------------------------------- */}
                  <TableRow>
                    <TableCell
                      colSpan='4'
                      align='center'
                      style={{ fontWeight: "bold" }}
                    >
                      آب
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>اطلاعات</TableCell>
                    <TableCell></TableCell>
                    <TableCell>چک شد</TableCell>
                    <TableCell>تعویض شد</TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>ضد یخ</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.antiFreeze != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.antiFreeze === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>آب</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.water != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.water === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>آب باتری</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.battryWaterd != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.battryWaterd === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  {/* ------------------------------------- Filter ------------------------------------- */}
                  <TableRow>
                    <TableCell
                      colSpan='4'
                      align='center'
                      style={{ fontWeight: "bold" }}
                    >
                      فیلتر
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>اطلاعات</TableCell>
                    <TableCell></TableCell>
                    <TableCell>چک شد</TableCell>
                    <TableCell>تعویض شد</TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>فیلتر روغن</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.oilFilter != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.oilFilter === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>فیلتر هوا</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.airFilter != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.airFilter === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>فیلتر اطاق</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.cabineFilter != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.cabineFilter === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>فیلتر بنزین</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.gasolineFilter != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.gasolineFilter === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  {/* ------------------------------------- Oil ------------------------------------- */}
                  <TableRow>
                    <TableCell
                      colSpan='4'
                      align='center'
                      style={{ fontWeight: "bold" }}
                    >
                      روغن
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>اطلاعات</TableCell>
                    <TableCell></TableCell>
                    <TableCell>چک شد</TableCell>
                    <TableCell>تعویض شد</TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>روغن موتور</TableCell>
                    <TableCell>{this.state.data.enginOilName}</TableCell>
                    <TableCell>
                      {this.state.data.enginOil != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.enginOil === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>روغن هیدرولیک</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.hidrolicOil != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.hidrolicOil === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>روغن ترمز</TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.state.data.brakeOil != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.brakeOil === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>روغن واسکازین</TableCell>
                    <TableCell>{this.state.data.vaskazinName}</TableCell>
                    <TableCell>
                      {this.state.data.roghan_vaskazin != null ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                    <TableCell>
                      {this.state.data.roghan_vaskazin === true ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </TableCell>
                  </TableRow>
                  {/* ------------------------------------- Machine ------------------------------------- */}
                  <TableRow>
                    <TableCell
                      colSpan='4'
                      align='center'
                      style={{ fontWeight: "bold" }}
                    >
                      خودرو
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>اطلاعات</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>داده ها</TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>کیلومتر فعلی</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>
                      {this.state.data.curentKM}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>کیلومتر بعدی</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>{this.state.data.nextKM}</TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>نوع خودرو</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>
                      {this.state.data.machineType}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>پلاک خودرو</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>
                      {this.state.data.licenceNumberPlate}
                    </TableCell>
                  </TableRow>
                  <TableRow hover tabIndex={-1}>
                    <TableCell>شماره همراه</TableCell>
                    <TableCell></TableCell>
                    <TableCell colSpan='2'>{this.state.data.tell}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id='message-id'> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Brand.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Brand));
